import {SELECT_OPTION} from "@/components/types";
import {TFunction} from "i18next";

export const BASE_PATH_NAME = '';

export const BASE_PATH = '';

export const defaultLoginBackgroundImage = `url(${BASE_PATH}/images/security_3.png)`;

export const defaultTags = {
    title: "MCJ",
    icons: {
        icon: "/images/mcjLogo.jpeg"
    }
}

export const pagePrefix_students = process.env.NODE_ENV === "production" ? "" : "/students";

export const pagePrefix_admin = process.env.NODE_ENV === "production" ? "" : "/admin"

export const searchTypeOptions: SELECT_OPTION[] = [
    {
        label: 'global:all',
        value: 1,
    },
    {
        label: 'global:rollNo',
        value: 2
    },
    {
        label: 'global:name',
        value: 3
    },
    {
        label: 'global:fatherName',
        value: 4
    },
    {
        label: 'global:motherName',
        value: 5
    },
    {
        label: 'global:userId',
        value: 6
    }
];

export const getUserStatuses = (t: TFunction, status: number = 0): [SELECT_OPTION[], string] => {
    const statuses = [
        {
            value: 100,
            label: t('details.inactive')
        },
        {
            value: 1,
            label: t('details.active')
        },
        {
            value: 2,
            label: t('details.suspended')
        },
        {
            value: 3,
            label: t('details.blocked')
        }
    ];
    const temp = statuses.filter(a => a.value === status)
    return [statuses, temp?.length ? temp[0].label : statuses[0].label];
}